import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import ModifiedByInfo from "./../../../Common/Footers/ModifiedByInfo";
import Select from '@material-ui/core/Select';
import moment from 'moment';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import appFetch from '../../../../api/appFetch.js';
import { PauseReasonsUrl, PauseReasonsWithIdUrl } from '../../../../constants/apiUrls.js';
import EnhancedDropdownComponent from '../../../Common/Dropdowns/EnhancedDropdownComponent.js';

export default class PauseReasonCreation extends Component {
    constructor(props) {
        super(props);

        var editedPauseReason = undefined;
        var type = undefined;
        var id = 0;

        if (this.props.location !== undefined && this.props.location.state !== undefined) {
            editedPauseReason = this.props.location.state.editedPauseReason;
            id = parseInt(this.props.editedPauseReasonId);
        }
        else if (this.props != undefined) {
            if (this.props.type !== undefined) type = this.props.type;
            if (this.props.editedPauseReasonId !== undefined) id = parseInt(this.props.editedPauseReasonId);
        }

        this.state = {
            id: id,
            type: type,
            description: "",
            modifiedByAvatar: "",
            modifiedByName: "",
            modifiedOn: "",
            editedPauseReason: editedPauseReason,
            loading: this.props.editedPauseReasonId !== undefined,
            redirect: false,
            requestInProgress: false,
            redirect: null,
            open: true,
            pauseReasonWasCreated: false,
        };
    }

    componentDidMount() {
        if (this.props.location !== undefined && this.props.location.state !== undefined && this.props.location.state.editedPauseReason !== undefined) {
            this.getEditegPauseReasonDetails(this.props.location.state.editedPauseReason);
        } else if (this.state.id != undefined && this.state.id > 0) {
            this.getPauseReasonDetails();
        }
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/pausereasons" });
    };

    handleChange = e => {
        var value = e.target.value;
        if (value.replace) {
            value = value.replace(/^\s+/, "");
        }
        this.setState({ [e.target.name]: value }, () => { this.checkIfRequestIsValid(false) });
    };

    handleKeyUp = e => {
        this.setState({ [e.target.name]: e.target.value })
    };


    checkIfRequestIsValid(displayErrorMessage) {
        let resources = this.props.resources;
        var isValidRequest = true;

        if (this.state.description.trim().length <= 0) {
            if (displayErrorMessage) DisplayMessage(resources["InvalidDescription"], "error");
            isValidRequest = false;
        }

        if (this.state.type === "0") {
            DisplayMessage(resources["InvalidType"], "error");
            return;
        }

        return isValidRequest;
    }

    isValidForm = () => {
        const { description, type } = this.state;

        if (!description || description.trim().length === 0) {
            return false;
        }

        if (!type || parseInt(type) === 0) {
            return false;
        }

        return true;
    }

    handleSubmit = () => {
        if (this.state.id == 0) {
            this.saveNewPauseReason();
            return;
        }

        this.saveEditedPauseReason();
    }

    saveNewPauseReason = () => {
        let resources = this.props.resources;

        if (!this.checkIfRequestIsValid(true)) {
            return;
        }

        this.setState({ requestInProgress: true });

        var json = JSON.stringify({
            type: this.state.type,
            description: this.state.description,
        });

        appFetch({
            url: PauseReasonsUrl(),
            method: 'POST',
            body: json,
            onSuccess: (data) => {
                DisplayMessage(resources["NewPauseReasonWasSaved"], "success");
                this.setState({ pausereasonWasCreated: true, redirect: "/pausereasons" });
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    saveEditedPauseReason = () => {
        let resources = this.props.resources;

        if (!this.checkIfRequestIsValid(true)) return;
        this.setState({ requestInProgress: true });

        var json = JSON.stringify({
            description: this.state.description,
            type: this.state.type
        });

        appFetch({
            url: PauseReasonsWithIdUrl(this.state.id),
            method: 'PUT',
            body: json,
            onSuccess: (data) => {
                DisplayMessage(resources["PauseReasonEditedSuccessfully"], "success");
                this.setState({ pausereasonWasCreated: true, redirect: "/pausereasons" });
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    getPauseReasonDetails = () => {
        const { id } = this.state;

        this.setState({ requestInProgress: true });
        let url = PauseReasonsUrl();

        appFetch({
            url: url,
            onSuccess: (data) => {
                var existsPauseReason = false;
                var editedPauseReason = undefined;

                data.forEach(function (row) {

                    if (row.id === id) {
                        existsPauseReason = true;
                        editedPauseReason = row;
                    }
                });

                if (existsPauseReason) {
                    this.setState({
                        id: editedPauseReason.id,
                        type: editedPauseReason.type,
                        description: editedPauseReason.description,
                        modifiedOn: !editedPauseReason.modifiedOn ? editedPauseReason.createdOn : editedPauseReason.modifiedOn,
                        modifiedByAvatar: editedPauseReason.modifiedBy ? editedPauseReason.modifiedBy.avatar : editedPauseReason.createdBy.avatar,
                        modifiedByName: editedPauseReason.modifiedBy ? `${editedPauseReason.modifiedBy.firstName} ${editedPauseReason.modifiedBy.lastName}` : `${editedPauseReason.createdBy.firstName} ${editedPauseReason.createdBy.lastName}`,
                        requestInProgress: false,
                        loading: false
                    });
                } else {
                    this.setState({ open: false, redirect: "/pausereasons" });
                }
            },
            onError: (data) => {
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    getEditegPauseReasonDetails = (editedPuaseReason) => {
        this.setState({
            id: editedPuaseReason.id,
            type: editedPuaseReason.type,
            description: editedPuaseReason.description,
            modifiedOn: !editedPuaseReason.modifiedOn ? editedPuaseReason.createdOn : editedPuaseReason.modifiedOn,
            modifiedByAvatar: editedPuaseReason.modifiedBy ? editedPuaseReason.modifiedBy.avatar : editedPuaseReason.createdBy.avatar,
            modifiedByName: editedPuaseReason.modifiedBy ? `${editedPuaseReason.modifiedBy.firstName} ${editedPuaseReason.modifiedBy.lastName}` : `${editedPuaseReason.createdBy.firstName} ${editedPuaseReason.createdBy.lastName}`,
            requestInProgress: false,
            loading: false,
        });
    }

    renderModifiedByInfo = () => {
        if (this.state.id > 0) {
          return (
            <ModifiedByInfo
              resources={this.props.resources}
              modifiedByAvatar={this.state.modifiedByAvatar}
              modifiedOn={this.state.modifiedOn}
              modifiedByName={this.state.modifiedByName}
              className="mt-3"
            />
          );
        }

        return;
    }

    renderForm() {
        const handleSubmit = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.handleSubmit();
        };
        const { description, type } = this.state;

        var resources = this.props.resources;
        var helperTextDescription = description.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";


        return (
            <div>
                <Paper elevation={3} className="p-4 mt-3 mb-3">
                    <Form onSubmit={handleSubmit} >
                        <Form.Group className="d-flex">
                            <div className="col-3"></div>
                            <div className="col-6" style={{ padding: 0 }}>
                                <EnhancedDropdownComponent
                                    id="type-dropdown"
                                    labelText={resources["Type"]}
                                    value={type ?? 0}
                                    options={[
                                        { key: 3, name: resources["Dossiers"] },
                                        { key: 4, name: resources["RepairOrderItems"] },
                                    ]}
                                    placeholder={resources["SelectType"]}
                                    inputName="type"
                                    handleChange={this.handleChange}
                                    addMarginBottom={false}
                                    helperText={resources["IsMandatory"]}
                                    required
                                    disabled={this.state.id > 0}
                                />
                            </div>
                            <div className="col-3"></div>
                        </Form.Group>

                        <Form.Group style={{ display: "flex" }}>
                            <div className="col-3"></div>
                            <ThemeProvider theme={SelectTheme}>
                                <TextField className={"col-6 " + helperTextDescription} id="pausereason-description" label={resources["Description"]}
                                    helperText={resources["InputOfDescriptionIsMandatory"]} value={description}
                                    variant="outlined" name="description" onChange={this.handleChange} onKeyUp={this.handleKeyUp} inputProps={{ maxLength: 25 }} />
                            </ThemeProvider >
                        </Form.Group>
                        {this.renderModifiedByInfo()}
                    </Form>
                </Paper>
            </div >
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
            {this.renderForm()}
        </div>;
    }

    render() {
        const { redirect, open, pausereasonWasCreated, outletId, id, requestInProgress, type } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect;

        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: pausereasonWasCreated, outletId, type } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky ">
                        <Toolbar>
                            <IconButton id="close-add-pausereason" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {id != undefined && id > 0 ? resources["EditPauseReasonTitle"] : resources["AddNewPauseReasonTitle"]}
                            </Typography>
                            <Button id="pausereason-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div >
        );
    }
}